<template>
  <div>
    <p class="font-bold ma-0">
      {{ $t('filters.filter_other') }}
    </p>
    <div>
      <v-form @submit.prevent="onSubmit">
        <v-select
          v-if="filtersEnabled.includes('eventName')"
          dense
          outlined
          placeholder=" "
          class="pt-4"
          v-model="filters.eventName"
          :items="eventNameOptions"
          :label="$t('common.event_name')"
        />

        <v-select
          v-if="filtersEnabled.includes('eventSource')"
          dense
          outlined
          placeholder=" "
          v-model="filters.eventSource"
          :items="eventSourceOptions"
          :label="$t('auditlogs.filters.event_source')"
        />

        <v-select
          v-if="filtersEnabled.includes('sourceType')"
          dense
          outlined
          placeholder=" "
          v-model="filters.sourceType"
          :items="sourceTypeOptions"
          :label="$t('auditlogs.filters.source_type')"
        />

        <v-text-field
          v-if="filtersEnabled.includes('sourceAccountId')"
          outlined
          dense
          v-model="filters.sourceAccountId"
          placeholder=" "
          :label="$t('auditlogs.filters.source_account_id')"
        />

        <v-text-field
          v-if="filtersEnabled.includes('sourceOrganizationId')"
          outlined
          dense
          v-model="filters.sourceOrganizationId"
          placeholder=" "
          :label="$t('auditlogs.filters.source_organization_id')"
        />

        <v-text-field
          v-if="filtersEnabled.includes('targetAccountId')"
          outlined
          dense
          v-model="filters.targetAccountId"
          placeholder=" "
          :label="$t('auditlogs.filters.target_account_id')"
        />

        <v-select
          v-if="filtersEnabled.includes('targetType')"
          dense
          outlined
          placeholder=" "
          v-model="filters.targetType"
          :items="targetTypeOptions"
          :label="$t('auditlogs.filters.target_type')"
        />

        <v-text-field
          v-if="filtersEnabled.includes('targetId')"
          outlined
          dense
          v-model="filters.targetId"
          placeholder=" "
          :label="$t('auditlogs.filters.target_id')"
        />

        <v-text-field
          v-if="filtersEnabled.includes('targetOrganizationId')"
          outlined
          dense
          v-model="filters.targetOrganizationId"
          placeholder=" "
          :label="$t('auditlogs.filters.target_organization_id')"
        />

        <v-select
          v-if="filtersEnabled.includes('responseType')"
          dense
          outlined
          placeholder=" "
          v-model="filters.responseType"
          :items="responseTypeOptions"
          :label="$t('auditlogs.filters.response_type')"
        />

        <v-select
          v-if="filtersEnabled.includes('responseCode')"
          dense
          outlined
          placeholder=" "
          v-model="filters.responseCode"
          :items="responseCodeOptions"
          :label="$t('auditlogs.filters.response_code')"
        />
        <div class="d-flex justify-end">
          <Button
            plain
            class="me-2"
            color="gray darken-1"
            :text="$t('filters.clear')"
            @click="$emit('onClear')"
          />

          <Button color="primary" :text="$t('filters.apply')" type="submit" />
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import Button from '@/components/UI/Button'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'AuditLogsFilters',

  mixins: [mixin],

  components: { Button },
  props: {
    filtersEnabled: Array,
  },
  data() {
    return {
      eventNameOptions: [
        { text: this.$t('logs.any'), value: 'any' },
        {
          text: this.$t('logs.account_bulk_operation'),
          value: 'account.bulkOperation',
        },
        { text: this.$t('logs.account_created'), value: 'account.created' },
        { text: this.$t('logs.account_deleted'), value: 'account.deleted' },
        {
          text: this.$t('logs.account_get_authentication_type'),
          value: 'account.getAuthenticationType',
        },
        {
          text: this.$t('logs.account_password_changed'),
          value: 'account.passwordChanged',
        },
        {
          text: this.$t('logs.account_registered'),
          value: 'account.registered',
        },
        {
          text: this.$t('logs.account_reset_account'),
          value: 'account.resetAccount',
        },
        { text: this.$t('logs.account_retrieved'), value: 'account.retrieved' },
        {
          text: this.$t('logs.account_status_retrieved'),
          value: 'account.statusRetrieved',
        },
        {
          text: this.$t('logs.account_tags_updated'),
          value: 'account.tagsUpdated',
        },
        { text: this.$t('logs.account_updated'), value: 'account.updated' },
        {
          text: this.$t('logs.accounts_retrieved'),
          value: 'accounts.retrieved',
        },
        {
          text: this.$t('logs.active_challenges_stats_retrieved'),
          value: 'activeChallengesStats.retrieved',
        },
        { text: this.$t('logs.api_key_created'), value: 'APIKey.created' },
        { text: this.$t('logs.api_key_deleted'), value: 'APIKey.deleted' },
        { text: this.$t('logs.api_key_retrieved'), value: 'APIKey.retrieved' },
        { text: this.$t('logs.api_key_updated'), value: 'APIKey.updated' },
        {
          text: this.$t('logs.api_keys_retrieved'),
          value: 'APIKeys.retrieved',
        },
        {
          text: this.$t('logs.attachment_created'),
          value: 'attachment.created',
        },
        {
          text: this.$t('logs.attachment_deleted'),
          value: 'attachment.deleted',
        },
        {
          text: this.$t('logs.attachments_retrieved'),
          value: 'attachments.retrieved',
        },
        { text: this.$t('logs.attribute_created'), value: 'attribute.created' },
        {
          text: this.$t('logs.attribute_retrieved'),
          value: 'attribute.retrieved',
        },
        { text: this.$t('logs.attribute_updated'), value: 'attribute.updated' },
        {
          text: this.$t('logs.attributes_retrieved'),
          value: 'attributes.retrieved',
        },
        {
          text: this.$t('logs.categories_retrieved'),
          value: 'categories.retrieved',
        },
        {
          text: this.$t('logs.category_organization_rule_created'),
          value: 'categoryOrganizationRule.created',
        },
        {
          text: this.$t('logs.category_organization_rule_deleted'),
          value: 'categoryOrganizationRule.deleted',
        },
        {
          text: this.$t('logs.category_organization_rule_retrieved'),
          value: 'categoryOrganizationRule.retrieved',
        },
        {
          text: this.$t('logs.category_organization_rule_updated'),
          value: 'categoryOrganizationRule.updated',
        },
        {
          text: this.$t('logs.category_organization_rules_retrieved'),
          value: 'categoryOrganizationRules.retrieved',
        },
        {
          text: this.$t('logs.category_site_rule_created'),
          value: 'categorySiteRule.created',
        },
        {
          text: this.$t('logs.category_site_rule_updated'),
          value: 'categorySiteRule.updated',
        },
        {
          text: this.$t('logs.category_site_rules_retrieved'),
          value: 'categorySiteRules.retrieved',
        },
        { text: this.$t('logs.challenge_created'), value: 'challenge.created' },
        { text: this.$t('logs.challenge_deleted'), value: 'challenge.deleted' },
        {
          text: this.$t('logs.challenge_leaderboard_retrieved'),
          value: 'challengeLeaderboard.retrieved',
        },
        {
          text: this.$t('logs.challenge_link_created'),
          value: 'challengeLink.created',
        },
        {
          text: this.$t('logs.challenge_link_deleted'),
          value: 'challengeLink.deleted',
        },
        {
          text: this.$t('logs.challenge_retrieved'),
          value: 'challenge.retrieved',
        },
        { text: this.$t('logs.challenge_updated'), value: 'challenge.updated' },
        {
          text: this.$t('logs.challenges_retrieved'),
          value: 'challenges.retrieved',
        },
        { text: this.$t('logs.checklist_created'), value: 'Checklist.created' },
        { text: this.$t('logs.checklist_deleted'), value: 'Checklist.deleted' },
        {
          text: this.$t('logs.checklist_retrieved'),
          value: 'Checklist.retrieved',
        },
        { text: this.$t('logs.checklist_updated'), value: 'Checklist.updated' },
        {
          text: this.$t('logs.checklist_response_created'),
          value: 'ChecklistResponse.created',
        },
        {
          text: this.$t('logs.checklist_response_deleted'),
          value: 'ChecklistResponse.deleted',
        },
        {
          text: this.$t('logs.checklist_response_retrieved'),
          value: 'ChecklistResponse.retrieved',
        },
        {
          text: this.$t('logs.checklist_response_updated'),
          value: 'ChecklistResponse.updated',
        },
        { text: this.$t('logs.coaches_retrieved'), value: 'coaches.retrieved' },
        {
          text: this.$t('logs.collaborators_retrieved'),
          value: 'collaborators.retrieved',
        },
        { text: this.$t('logs.comment_created'), value: 'comment.created' },
        { text: this.$t('logs.comment_deleted'), value: 'comment.deleted' },
        { text: this.$t('logs.comment_retrieved'), value: 'comment.retrieved' },
        { text: this.$t('logs.comment_updated'), value: 'comment.updated' },
        {
          text: this.$t('logs.comments_retrieved'),
          value: 'comments.retrieved',
        },
        { text: this.$t('logs.control_created'), value: 'control.created' },
        { text: this.$t('logs.control_deleted'), value: 'control.deleted' },
        { text: this.$t('logs.control_retrieved'), value: 'control.retrieved' },
        { text: this.$t('logs.control_updated'), value: 'control.updated' },
        {
          text: this.$t('logs.controls_retrieved'),
          value: 'controls.retrieved',
        },
        {
          text: this.$t('logs.countries_retrieved'),
          value: 'countries.retrieved',
        },
        { text: this.$t('logs.course_created'), value: 'course.created' },
        { text: this.$t('logs.course_deleted'), value: 'course.deleted' },
        { text: this.$t('logs.course_retrieved'), value: 'course.retrieved' },
        { text: this.$t('logs.course_updated'), value: 'course.updated' },
        {
          text: this.$t('logs.course_progress_updated'),
          value: 'courseProgress.updated',
        },
        { text: this.$t('logs.courses_retrieved'), value: 'courses.retrieved' },
        {
          text: this.$t('logs.course_tree_retrieved'),
          value: 'courseTree.retrieved',
        },
        { text: this.$t('logs.finding_created'), value: 'finding.created' },
        { text: this.$t('logs.finding_deleted'), value: 'finding.deleted' },
        { text: this.$t('logs.finding_retrieved'), value: 'finding.retrieved' },
        { text: this.$t('logs.finding_updated'), value: 'finding.updated' },
        {
          text: this.$t('logs.findings_bulk_operation'),
          value: 'finding.bulkOperation',
        },
        {
          text: this.$t('logs.findings_retrieved'),
          value: 'findings.retrieved',
        },
        { text: this.$t('logs.group_created'), value: 'Group.created' },
        { text: this.$t('logs.group_deleted'), value: 'Group.deleted' },
        { text: this.$t('logs.group_retrieved'), value: 'Group.retrieved' },
        { text: this.$t('logs.group_updated'), value: 'Group.updated' },
        { text: this.$t('logs.groups_retrieved'), value: 'Groups.retrieved' },
        { text: this.$t('logs.highlight_created'), value: 'Highlight.created' },
        { text: this.$t('logs.highlight_deleted'), value: 'Highlight.deleted' },
        {
          text: this.$t('logs.highlight_retrieved'),
          value: 'Highlight.retrieved',
        },
        { text: this.$t('logs.highlight_updated'), value: 'Highlight.updated' },
        {
          text: this.$t('logs.improvement_idea_created'),
          value: 'improvementIdea.created',
        },
        {
          text: this.$t('logs.improvement_idea_deleted'),
          value: 'improvementIdea.deleted',
        },
        {
          text: this.$t('logs.improvement_idea_retrieved'),
          value: 'improvementIdea.retrieved',
        },
        {
          text: this.$t('logs.improvement_idea_updated'),
          value: 'improvementIdea.updated',
        },
        {
          text: this.$t('logs.insights_retrieved'),
          value: 'insights.retrieved',
        },
        { text: this.$t('logs.lesson_created'), value: 'lesson.created' },
        { text: this.$t('logs.lesson_deleted'), value: 'lesson.deleted' },
        { text: this.$t('logs.lesson_retrieved'), value: 'lesson.retrieved' },
        { text: this.$t('logs.lesson_updated'), value: 'lesson.updated' },
        { text: this.$t('logs.lessons_retrieved'), value: 'lessons.retrieved' },
        { text: this.$t('logs.like_created'), value: 'like.created' },
        { text: this.$t('logs.like_deleted'), value: 'like.deleted' },
        { text: this.$t('logs.likes_retrieved'), value: 'likes.retrieved' },
        { text: this.$t('logs.media_created'), value: 'media.created' },
        { text: this.$t('logs.media_retrieved'), value: 'media.retrieved' },
        { text: this.$t('logs.module_created'), value: 'module.created' },
        { text: this.$t('logs.module_deleted'), value: 'module.deleted' },
        { text: this.$t('logs.module_retrieved'), value: 'module.retrieved' },
        { text: this.$t('logs.module_updated'), value: 'module.updated' },
        { text: this.$t('logs.modules_retrieved'), value: 'modules.retrieved' },
        {
          text: this.$t('logs.most_popular_revs_stats_retrieved'),
          value: 'mostPopularRevsStats.retrieved',
        },
        { text: this.$t('logs.objective_created'), value: 'objective.created' },
        { text: this.$t('logs.objective_deleted'), value: 'objective.deleted' },
        {
          text: this.$t('logs.objective_retrieved'),
          value: 'objective.retrieved',
        },
        { text: this.$t('logs.objective_updated'), value: 'objective.updated' },
        {
          text: this.$t('logs.objectives_retrieved'),
          value: 'objectives.retrieved',
        },
        {
          text: this.$t('logs.organization_created'),
          value: 'organization.created',
        },
        {
          text: this.$t('logs.organization_deleted'),
          value: 'organization.deleted',
        },
        {
          text: this.$t('logs.organization_disabled'),
          value: 'organization.disabled',
        },
        {
          text: this.$t('logs.organization_enabled'),
          value: 'organization.enabled',
        },
        {
          text: this.$t('logs.organization_retrieved'),
          value: 'organization.retrieved',
        },
        {
          text: this.$t('logs.organization_updated'),
          value: 'organization.updated',
        },
        {
          text: this.$t('logs.organizations_retrieved'),
          value: 'organizations.retrieved',
        },
        {
          text: this.$t('logs.organizations_tags_retrieved'),
          value: 'organizationsTags.retrieved',
        },
        { text: this.$t('logs.password_updated'), value: 'password.updated' },
        { text: this.$t('logs.points_created'), value: 'points.created' },
        {
          text: this.$t('logs.problem_solving_created'),
          value: 'problemSolving.created',
        },
        {
          text: this.$t('logs.problem_solving_deleted'),
          value: 'problemSolving.deleted',
        },
        {
          text: this.$t('logs.problem_solving_retrieved'),
          value: 'problemSolving.retrieved',
        },
        {
          text: this.$t('logs.problem_solving_updated'),
          value: 'problemSolving.updated',
        },
        {
          text: this.$t('logs.quick_action_created'),
          value: 'quickAction.created',
        },
        {
          text: this.$t('logs.quick_action_deleted'),
          value: 'quickAction.deleted',
        },
        {
          text: this.$t('logs.quick_action_retrieved'),
          value: 'quickAction.retrieved',
        },
        {
          text: this.$t('logs.quick_action_updated'),
          value: 'quickAction.updated',
        },
        {
          text: this.$t('logs.recognition_created'),
          value: 'recognition.created',
        },
        {
          text: this.$t('logs.recognition_deleted'),
          value: 'recognition.deleted',
        },
        {
          text: this.$t('logs.recognition_retrieved'),
          value: 'recognition.retrieved',
        },
        {
          text: this.$t('logs.recognition_updated'),
          value: 'recognition.updated',
        },
        {
          text: this.$t('logs.recognitions_retrieved'),
          value: 'recognitions.retrieved',
        },
        {
          text: this.$t('logs.recover_password_created'),
          value: 'recoverpassword.created',
        },
        {
          text: this.$t('logs.recover_password_retrieved'),
          value: 'recoverpassword.retrieved',
        },
        {
          text: this.$t('logs.recover_password_created'),
          value: 'recoverPassword.created',
        },
        {
          text: this.$t('logs.recover_password_retrieved'),
          value: 'recoverPassword.retrieved',
        },
        {
          text: this.$t('logs.recover_password_updated'),
          value: 'recoverPassword.updated',
        },
        { text: this.$t('logs.reminder_created'), value: 'Reminder.created' },
        { text: this.$t('logs.reminder_deleted'), value: 'Reminder.deleted' },
        {
          text: this.$t('logs.reminder_retrieved'),
          value: 'Reminder.retrieved',
        },
        { text: this.$t('logs.reminder_updated'), value: 'Reminder.updated' },
        {
          text: this.$t('logs.reminders_retrieved'),
          value: 'Reminders.retrieved',
        },
        { text: this.$t('logs.report_created'), value: 'report.created' },
        { text: this.$t('logs.report_downloaded'), value: 'report.downloaded' },
        { text: this.$t('logs.report_retrieved'), value: 'report.retrieved' },
        { text: this.$t('logs.reports_created'), value: 'reports.created' },
        { text: this.$t('logs.reports_retrieved'), value: 'reports.retrieved' },
        { text: this.$t('logs.rev_created'), value: 'rev.created' },
        { text: this.$t('logs.rev_deleted'), value: 'rev.deleted' },
        { text: this.$t('logs.rev_retrieved'), value: 'rev.retrieved' },
        { text: this.$t('logs.rev_updated'), value: 'rev.updated' },
        {
          text: this.$t('logs.review_stats_retrieved'),
          value: 'reviewStats.retrieved',
        },
        {
          text: this.$t('logs.rev_implemented_created'),
          value: 'revImplemented.created',
        },
        {
          text: this.$t('logs.rev_implemented_retrieved'),
          value: 'revImplemented.retrieved',
        },
        {
          text: this.$t('logs.rev_items_retrieved'),
          value: 'revItems.retrieved',
        },
        { text: this.$t('logs.rev_like_created'), value: 'revLike.created' },
        { text: this.$t('logs.rev_like_deleted'), value: 'revLike.deleted' },
        {
          text: this.$t('logs.rev_validation_created'),
          value: 'RevValidation.created',
        },
        {
          text: this.$t('logs.rev_validation_deleted'),
          value: 'RevValidation.deleted',
        },
        {
          text: this.$t('logs.rev_validation_retrieved'),
          value: 'RevValidation.retrieved',
        },
        {
          text: this.$t('logs.rev_validation_updated'),
          value: 'RevValidation.updated',
        },
        { text: this.$t('logs.revs_retrieved'), value: 'revs.retrieved' },
        {
          text: this.$t('logs.revs_by_impact_stats_retrieved'),
          value: 'revsByImpactStats.retrieved',
        },
        {
          text: this.$t('logs.revs_by_state_stats_retrieved'),
          value: 'revsByStateStats.retrieved',
        },
        {
          text: this.$t('logs.revs_count_stats_retrieved'),
          value: 'revsCountStats.retrieved',
        },
        { text: this.$t('logs.routine_created'), value: 'routine.created' },
        {
          text: this.$t('logs.routine_definition_created'),
          value: 'routineDefinition.created',
        },
        {
          text: this.$t('logs.routine_definition_deleted'),
          value: 'routineDefinition.deleted',
        },
        {
          text: this.$t('logs.routine_definition_retrieved'),
          value: 'routineDefinition.retrieved',
        },
        {
          text: this.$t('logs.routine_definition_updated'),
          value: 'routineDefinition.updated',
        },
        {
          text: this.$t('logs.routine_definitions_retrieved'),
          value: 'routineDefinitions.retrieved',
        },
        { text: this.$t('logs.routine_deleted'), value: 'routine.deleted' },
        { text: this.$t('logs.routine_retrieved'), value: 'routine.retrieved' },
        { text: this.$t('logs.routine_updated'), value: 'routine.updated' },
        {
          text: this.$t('logs.routines_retrieved'),
          value: 'routines.retrieved',
        },
        { text: this.$t('logs.share_created'), value: 'share.created' },
        { text: this.$t('logs.signup_retrieved'), value: 'signup.retrieved' },
        { text: this.$t('logs.site_created'), value: 'site.created' },
        { text: this.$t('logs.site_retrieved'), value: 'site.retrieved' },
        { text: this.$t('logs.site_updated'), value: 'site.updated' },
        { text: this.$t('logs.sites_retrieved'), value: 'sites.retrieved' },
        {
          text: this.$t('logs.tag_created'),
          value: 'tag.created',
        },
        {
          text: this.$t('logs.tag_retrieved'),
          value: 'tag.retrieved',
        },
        {
          text: this.$t('logs.tag_updated'),
          value: 'tag.updated',
        },
        {
          text: this.$t('logs.tags_retrieved'),
          value: 'tag.retrieved',
        },
        {
          text: this.$t('logs.situation_type_organization_rule_created'),
          value: 'situationTypeOrganizationRule.retrieved',
        },
        {
          text: this.$t('logs.situation_type_organization_rule_deleted'),
          value: 'situationTypeOrganizationRule.retrieved',
        },
        {
          text: this.$t('logs.situation_type_organization_rule_updated'),
          value: 'situationTypeOrganizationRule.retrieved',
        },
        {
          text: this.$t('logs.situation_type_organization_rules_retrieved'),
          value: 'situationTypeOrganizationRules.retrieved',
        },
        {
          text: this.$t('logs.situation_type_site_rule_created'),
          value: 'situationTypeSiteRule.created',
        },
        {
          text: this.$t('logs.situation_type_site_rule_deleted'),
          value: 'situationTypeSiteRule.deleted',
        },
        {
          text: this.$t('logs.situation_type_site_rule_updated'),
          value: 'situationTypeSiteRule.updated',
        },
        {
          text: this.$t('logs.situation_type_site_rules_retrieved'),
          value: 'situationTypeSiteRules.retrieved',
        },
        {
          text: this.$t('logs.situation_types_retrieved'),
          value: 'situationTypess.retrieved',
        },
        {
          text: this.$t('logs.stream_accounts_retrieved'),
          value: 'streamAccounts.retrieved',
        },
        {
          text: this.$t('logs.stream_challenges_retrieved'),
          value: 'streamChallenges.retrieved',
        },
        {
          text: this.$t('logs.stream_people_retrieved'),
          value: 'streamPeople.retrieved',
        },
        { text: this.$t('logs.stream_retrieved'), value: 'stream.retrieved' },
        {
          text: this.$t('logs.stream_revs_retrieved'),
          value: 'streamRevs.retrieved',
        },
        { text: this.$t('logs.tag_created'), value: 'tag.created' },
        { text: this.$t('logs.tag_updated'), value: 'tag.updated' },
        { text: this.$t('logs.tags_retrieved'), value: 'tags.retrieved' },
        { text: this.$t('logs.team_created'), value: 'team.created' },
        { text: this.$t('logs.team_deleted'), value: 'team.deleted' },
        { text: this.$t('logs.team_retrieved'), value: 'team.retrieved' },
        { text: this.$t('logs.team_updated'), value: 'team.updated' },
        { text: this.$t('logs.teams_retrieved'), value: 'teams.retrieved' },
        {
          text: this.$t('logs.total_revs_in_range_stats_retrieved'),
          value: 'totalRevsInRangeStats.retrieved',
        },
        {
          text: this.$t('logs.user_device_registered'),
          value: 'user.deviceRegistered',
        },
        { text: this.$t('logs.user_login'), value: 'user.login' },
        { text: this.$t('logs.user_logout'), value: 'user.logout' },
        {
          text: this.$t('logs.users_by_reverscore_stats_retrieved'),
          value: 'usersByReverscoreStats.retrieved',
        },
        {
          text: this.$t('logs.users_count_stats_retrieved'),
          value: 'usersCountStats.retrieved',
        },
        { text: this.$t('logs.version_retrieved'), value: 'version.retrieved' },
        { text: this.$t('logs.webhook_created'), value: 'Webhook.created' },
        { text: this.$t('logs.webhook_deleted'), value: 'Webhook.deleted' },
        { text: this.$t('logs.webhook_retrieved'), value: 'Webhook.retrieved' },
        { text: this.$t('logs.webhook_updated'), value: 'Webhook.updated' },
        {
          text: this.$t('logs.webhooks_retrieved'),
          value: 'Webhooks.retrieved',
        },
      ],
      sourceTypeOptions: ['any', 'user', 'system'],
      eventSourceOptions: [
        'any',
        'api',
        'notifications',
        'gateway',
        'reports',
        'search',
      ],
      targetTypeOptions: [
        { text: this.$t('logs.any'), value: 'any' },
        { text: this.$t('logs.account'), value: 'account' },
        { text: this.$t('logs.api_key'), value: 'APIKey' },
        { text: this.$t('logs.attachment'), value: 'attachment' },
        { text: this.$t('logs.attribute'), value: 'attribute' },
        { text: this.$t('logs.category'), value: 'category' },
        {
          text: this.$t('logs.category_organization_rule'),
          value: 'categoryOrganizationRule',
        },
        { text: this.$t('logs.category_site_rule'), value: 'categorySiteRule' },
        { text: this.$t('logs.challenge'), value: 'challenge' },
        { text: this.$t('logs.challenge_link'), value: 'challengeLink' },
        { text: this.$t('logs.checklist'), value: 'Checklist' },
        {
          text: this.$t('logs.checklist_response'),
          value: 'ChecklistResponse',
        },
        { text: this.$t('logs.comment'), value: 'comment' },
        { text: this.$t('logs.finding'), value: 'finding' },
        { text: this.$t('logs.group'), value: 'Group' },
        { text: this.$t('logs.highlight'), value: 'Highlight' },
        { text: this.$t('logs.improvement_idea'), value: 'improvementIdea' },
        { text: this.$t('logs.insights'), value: 'insights' },
        { text: this.$t('logs.like'), value: 'like' },
        { text: this.$t('logs.media'), value: 'media' },
        { text: this.$t('logs.module'), value: 'module' },
        { text: this.$t('logs.objective'), value: 'objective' },
        { text: this.$t('logs.organization'), value: 'organization' },
        { text: this.$t('logs.password'), value: 'password' },
        { text: this.$t('logs.problem_solving'), value: 'problemSolving' },
        { text: this.$t('logs.quick_action'), value: 'QuickAction' },
        { text: this.$t('logs.recognition'), value: 'recognition' },
        { text: this.$t('logs.recover_password'), value: 'recoverPassword' },
        { text: this.$t('logs.reminder'), value: 'Reminder' },
        { text: this.$t('logs.report'), value: 'report' },
        { text: this.$t('logs.reports'), value: 'reports' },
        { text: this.$t('logs.rev'), value: 'rev' },
        { text: this.$t('logs.rev_item'), value: 'revItem' },
        { text: this.$t('logs.rev_validation'), value: 'RevValidation' },
        { text: this.$t('logs.routine'), value: 'routine' },
        {
          text: this.$t('logs.routine_definition'),
          value: 'routineDefinition',
        },
        { text: this.$t('logs.signup'), value: 'signup' },
        { text: this.$t('logs.site'), value: 'site' },
        { text: this.$t('logs.tag'), value: 'tag' },
        {
          text: this.$t('logs.situation_type_organization_rule'),
          value: 'situationTypeOrganizationRule',
        },
        {
          text: this.$t('logs.situation_type_site_rule'),
          value: 'situationTypeSiteRule',
        },
        { text: this.$t('logs.situation_types'), value: 'situationTypes' },
        { text: this.$t('logs.stats'), value: 'stats' },
        { text: this.$t('logs.tag'), value: 'tag' },
        { text: this.$t('logs.team'), value: 'team' },
        { text: this.$t('logs.version'), value: 'version' },
        { text: this.$t('logs.webhook'), value: 'Webhook' },
      ],
      responseTypeOptions: ['any', 'success', 'error'],
      responseCodeOptions: [
        'any',
        '200',
        '201',
        '300',
        '301',
        '400',
        '401',
        '403',
        '404',
        '406',
        '500',
      ],
    }
  },
  created() {
    this.$emit('events', this.eventNameOptions)
    this.$emit('targetTypes', this.targetTypeOptions)
  },
  computed: {
    ...mapGetters({
      currentFilters: 'filters',
    }),
    filters: {
      get() {
        return { ...this.currentFilters }
      },
      set(values) {
        this.setFilters(values)
      },
    },
  },
  methods: {
    ...mapMutations({
      setFilters: 'audit/SET_FILTERS',
    }),

    onSubmit() {
      this.$emit('filtersSet', this.filters)
    },
  },
}
</script>
